module.exports = __webpack_public_path__ + "img/icon60.cb9daadf.png";